import React from 'react';
import { SideBar } from './sidebar';
import i18n from '../../i18n';
import { HomeBanner } from '../home/homeBanner';
import {
  getDashboardSummary,
  getManagementDashboard,
  getMgmtCounts,
} from '../../models/management';
import { Modal } from 'react-bootstrap';
import { DashboardApproval } from './management/approvals';
import { DashboardTodays } from './management/todays';
import { DashboardWinners } from './management/winners';
import { DashboardRunning } from './management/running';
import {
  ArrowDown,
  Banknote,
  CalendarCheck2,
  CalendarX2,
  ChartLine,
  CheckCircle,
  ClipboardCheck,
  Clock,
  CreditCard,
  Gavel,
  Landmark,
  Loader,
  Loader2,
  Pause,
  ReceiptText,
  ShieldUser,
  SlidersHorizontal,
  TrendingUp,
  Trophy,
} from 'lucide-react';
import PaymentCard from '../common/PaymentCard';
import SummaryCard from '../common/SummaryCard';
import VatCard from '../common/VatCard';
import DateRangeSelector from '../common/DateRange';
import '../../styles/management-report.scss';
import ReportCard from '../common/ReportCard';
import ProjectCard from '../common/ProjectCard';
import ReportCardSkeleton from '../common/skelton/ReportCardSkelton';
import ProjectCardSkeleton from '../common/skelton/ProjectCardSkelton';

const types = {
  todays: `${i18n.t('todays')} ${i18n.t('auctions')}`,
  active: `${i18n.t('winners')}(${i18n.t('active')})`,
  previous: `${i18n.t('winners')}(${i18n.t('previous')})`,
  running: `${i18n.t('running')} ${i18n.t('auctions')}`,
};
export class Management extends React.Component {
  constructor() {
    super();
    this.state = {
      fromDate: null,
      toDate: null,
      // open_project_popup: false,
      // project_type: 'pending',
      // open_status_popup: false,
      // status_type: '',
      // wallet_balance: 0,
      // wallet_hold: 0,
      // wallet_withdraw: 0,
      // service_vat: 0,
      // is_counts_loading: false,
      // is_vat_loading: false,
      // section: '',
      is_status_loading: false,
      is_dashboard_loading: false,

      is_summary_loading: false,
      wallet_summary: null,
      vat_summary: null,
      auction_summary: null,
      project_summary: null,
    };
    this.loadCounts = this.loadCounts.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.loadCounts();
    this.loadDashboard();
    this.loadDashboardSummary();
  }

  handleInputChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
  }

  async loadCounts() {
    let { input } = this.state;
    let q = '';
    this.setState({ is_counts_loading: true });
    if (input.proj_type) {
      q = '?proj_type=' + input.proj_type;
      this.setState({
        is_proj_loading: true,
        is_vat_loading: false,
        is_status_loading: false,
        is_counts_loading: false,
      });
    }
    if (input.vat_type) {
      q = '?vat_type=' + input.vat_type;
      this.setState({
        is_vat_loading: true,
        is_proj_loading: false,
        is_status_loading: false,
        is_counts_loading: false,
      });
    }
    if (input.stat_type) {
      q = '?stat_type=' + input.stat_type;
      this.setState({
        is_status_loading: true,
        is_proj_loading: false,
        is_vat_loading: false,
        is_counts_loading: false,
      });
    }
    if (input && typeof input.fdate !== 'undefined') {
      q += '&fdate=' + input.fdate;
    }
    if (input && typeof input.tdate !== 'undefined') {
      q += '&tdate=' + input.tdate;
    }
    if (input && typeof input.s_fdate !== 'undefined') {
      q += '&s_fdate=' + input.s_fdate;
    }
    if (input && typeof input.s_tdate !== 'undefined') {
      q += '&s_tdate=' + input.s_tdate;
    }
    const response = await getMgmtCounts(q);
    if (response.success) {
      let data = response.data;
      let todays_count = data?.todays?.count || 0;
      let todays_bidders = data?.todays?.bidders || 0;

      let winners_count_active = data?.winners?.active?.count || 0;
      let winners_active_bidders = data?.winners?.active?.bidders || 0;
      let winners_count_previous = data?.winners?.previous?.count || 0;
      let winners_previous_bidders = data?.winners?.previous?.bidders || 0;

      let running_count = data?.running?.count || 0;
      let running_bidders = data?.running?.bidders || 0;

      let approvals_count_pending = data?.approvals?.pending?.count || 0;
      let pending_amount = data?.approvals?.pending?.amount || 0;
      let approvals_count_approved = data?.approvals?.approved?.count || 0;
      let approved_amount = data?.approvals?.approved?.amount || 0;
      let approvals_count_completed = data?.approvals?.completed?.count || 0;
      let completed_amount = data?.approvals?.completed?.amount || 0;

      let wallet_balance = data?.wallet?.balance || 0;
      let wallet_hold = data?.wallet?.hold || 0;
      let wallet_withdraw = data?.wallet?.current_withdraw || 0;
      let service_vat = data?.vat_info?.amount || 0;

      this.setState({
        todays_count,
        todays_bidders,
        winners_count_active,
        winners_active_bidders,
        winners_count_previous,
        winners_previous_bidders,
        running_count,
        running_bidders,
        approvals_count_pending,
        pending_amount,
        approvals_count_approved,
        approved_amount,
        approvals_count_completed,
        completed_amount,
        wallet_balance,
        wallet_hold,
        wallet_withdraw,
        service_vat,
      });
      this.setState({ is_counts_loading: false });
      this.setState({ is_vat_loading: false });
      this.setState({ is_status_loading: false });
      this.setState({ is_proj_loading: false });
    } else {
      this.setState({ is_counts_loading: false });
      this.setState({ is_vat_loading: false });
      this.setState({ is_status_loading: false });
      this.setState({ is_proj_loading: false });
    }
  }

  async loadDashboard() {
    let { fromDate, toDate } = this.state;

    let q = '';
    this.setState({ is_dashboard_loading: true });
    if (fromDate) {
      q = `?fromDate=${fromDate}`;
    }
    if (toDate) {
      q = `?toDate=${toDate}`;
    }
    try {
      const response = await getManagementDashboard(q);

      if (response.success) {
        const { wallet_summary } = response.data;

        this.setState({
          wallet_summary,
          is_counts_loading: false,
        });
      } else {
        this.setState({ is_counts_loading: false });
      }
    } catch (error) {
      this.setState({ is_counts_loading: false });
    }
  }
  async loadDashboardSummary() {
    let { fromDate, toDate } = this.state;
    let q = '';
    this.setState({ is_dashboard_loading: true });
    this.setState({ is_summary_loading: true });
    const params = new URLSearchParams();
    if (fromDate) {
      params.append('fromDate', fromDate);
    }
    if (toDate) {
      params.append('toDate', toDate);
    }

    q = params.toString() ? '?' + params.toString() : '';

    try {
      const response = await getDashboardSummary(q);

      if (response.success) {
        const { auction_summary, project_summary, vat_summary } = response.data;
        this.setState({
          auction_summary,
          project_summary,
          vat_summary,
          is_summary_loading: false,
        });
      } else {
        this.setState({ is_summary_loading: false });
      }
    } catch (error) {
      this.setState({ is_summary_loading: false });
    }
  }
  handleDateRangeChange = (dateRange) => {
    if (dateRange.fromDate) {
      this.setState({ fromDate: dateRange.fromDate });
    }
    if (dateRange.toDate) {
      this.setState({ toDate: dateRange.toDate });
    }
    if (dateRange.option === 'Today' || dateRange.option === 'Yesterday') {
      this.setState({ toDate: null });
    }
  };
  handleClear = () => {
    this.setState({ clearDate: Date.now(), fromDate: null, toDate: null });
  };
  handleSearch = () => {
    this.setState({ is_summary_loading: true });

    this.loadDashboardSummary();
  };

  render() {
    let { project_type, open_project_popup, open_status_popup, status_type } = this.state;

    return (
      <React.Fragment>
        <HomeBanner callbackForSupport={this.props.callbackForSupport} />
        <section className="sptb mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.is_side_bar && <SideBar />}
              </div>
              <div
                className={
                  this.state.is_side_bar
                    ? 'col-xl-12 col-lg-12 col-md-12 '
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                {/* <div className="card">
                  <div className="card-header d-flex justify-content-between">
                    <div className="d-flex w-30 w-mob-100">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                      <h3 className="card-title">
                        {i18n.t('mzadcom')} - {i18n.t('wallet')}
                      </h3>
                    </div>
                  </div>
                </div> */}
                {/* New Auction Status  */}
                <div className="management-report">
                  <div className="report-header">
                    <h4 className="title">Management Dashboard</h4>
                    {/* Date Filter  */}
                    <div className="filter-bar">
                      <div className="filter-bar-title">
                        Filter <SlidersHorizontal size={15} />{' '}
                      </div>

                      <div className="filter-action">
                        <DateRangeSelector
                          onChange={this.handleDateRangeChange}
                          clearTrigger={this.state.clearDate}
                        />

                        <div className="btn-group">
                          <button className="btn-new btn-new-filter" onClick={this.handleClear}>
                            Clear
                          </button>
                          <button
                            className="btn-new btn-new-filter"
                            onClick={this.handleSearch}
                            disabled={this.state.is_summary_loading}
                          >
                            {this.state.is_summary_loading ? (
                              <span
                                style={{
                                  color: 'white',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '5px',
                                }}
                              >
                                <Loader2 className="animate-spin" size={16} /> Loading
                              </span>
                            ) : (
                              'Search'
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="report-item">
                    <div className="report-item-header">
                      <p className="subtitle">Auction Summary</p>
                    </div>
                    <div className="report-item-content">
                      {this.state.is_summary_loading ? (
                        <>
                          {' '}
                          <ReportCardSkeleton />
                          <ReportCardSkeleton />
                          <ReportCardSkeleton />
                        </>
                      ) : (
                        <>
                          <ReportCard
                            className="auction-start"
                            icon={CalendarCheck2}
                            title="Auction Starts"
                            value={this.state.auction_summary?.auction_starts?.auctions || 0}
                            enrollment={
                              this.state.auction_summary?.auction_starts?.enrolls_count || 0
                            }
                            winners={{
                              label: 'winner',
                              count: this.state.auction_summary?.auction_starts?.winner_count || 0,
                              icon: <Trophy size={14} />,
                            }}
                          />
                          <ReportCard
                            className="auction-end"
                            icon={CalendarX2}
                            title="Auction Ends"
                            value={this.state.auction_summary?.auction_end?.auctions || 0}
                            enrollment={this.state.auction_summary?.auction_end?.enrolls_count || 0}
                            winners={{
                              label: 'winner',
                              count: this.state.auction_summary?.auction_end?.winner_count || 0,
                              icon: <Trophy size={14} />,
                            }}
                          />
                          <ReportCard
                            className="auction-running"
                            icon={Gavel}
                            title="Running Auction"
                            value={this.state.auction_summary?.auction_running?.auctions || 0}
                            enrollment={
                              this.state.auction_summary?.auction_running?.enrolls_count || 0
                            }
                            winners={{
                              label: 'strategy',
                              count:
                                this.state.auction_summary?.auction_running
                                  ?.strategy_enrolls_count || 0,
                              icon: <ShieldUser size={14} />,
                            }}
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="report-item">
                    <div className="report-item-header">
                      <p className="subtitle">Project Summary</p>
                    </div>
                    <div className="report-item-content">
                      {this.state.is_summary_loading ? (
                        <>
                          <ProjectCardSkeleton />
                          <ProjectCardSkeleton />
                          <ProjectCardSkeleton />
                          <ProjectCardSkeleton />
                        </>
                      ) : (
                        <>
                          <ProjectCard
                            className="pending"
                            icon={Clock}
                            title="Pending"
                            value={this.state.project_summary?.auction_pending || 0}
                          />
                          <ProjectCard
                            className="approved"
                            icon={CheckCircle}
                            title="Approved"
                            value={this.state.project_summary?.auction_approved || 0}
                          />
                          <ProjectCard
                            className="payment-done"
                            icon={CreditCard}
                            title="Payment Paid"
                            value={this.state.project_summary?.auction_paid || 0}
                          />
                          <ProjectCard
                            className="loading"
                            icon={Loader}
                            title="Loading"
                            value={this.state.project_summary?.auction_loading || 0}
                          />
                          <ProjectCard
                            className="completed"
                            icon={ClipboardCheck}
                            title="Completed"
                            value={this.state.project_summary?.auction_completed || 0}
                          />
                        </>
                      )}
                    </div>
                  </div>
                  <div className="report-item">
                    <div className="report-item-header">
                      <p className="subtitle">Profit & Vat Summary</p>
                    </div>
                    <div className="report-item-content">
                      {this.state.is_summary_loading ? (
                        <>
                          <ProjectCardSkeleton />
                          <ProjectCardSkeleton />
                          <ProjectCardSkeleton />
                        </>
                      ) : (
                        <>
                          <VatCard
                            className="service-charge"
                            icon={ChartLine}
                            title="Service Charge"
                            value={this.state.vat_summary?.service_charge.value || 0}
                            trend={this.state.vat_summary?.service_charge.trend}
                            percentage={this.state.vat_summary?.service_charge.percentage || 0}
                            timeframe={this.state.vat_summary?.service_charge.timeframe}
                          />

                          <VatCard
                            className="vat-service"
                            icon={ReceiptText}
                            title="Service Charge VAT"
                            value={this.state.vat_summary?.service_charge_vat.value || 0}
                            trend={this.state.vat_summary?.service_charge_vat.trend}
                            percentage={this.state.vat_summary?.service_charge_vat.percentage || 0}
                            timeframe={this.state.vat_summary?.service_charge_vat.timeframe}
                          />
                          <VatCard
                            className="vat-bid"
                            icon={Gavel}
                            title="Bid Amount VAT"
                            value={this.state.vat_summary?.bid_amount_vat.value || 0}
                            trend={this.state.vat_summary?.bid_amount_vat.trend}
                            percentage={this.state.vat_summary?.bid_amount_vat.percentage || 0}
                            timeframe={this.state.vat_summary?.bid_amount_vat.timeframe}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* New Wallet  Summary  */}
                <div className="wallet-summary">
                  <div className="wallet-summary-header d-flex align-item-center justify-content-between">
                    <div className="title">
                      <p className="subtitle">{i18n.t('wallet_summary')}</p>
                    </div>
                    {/* <div className="filter d-flex gap-3">
                      <DateRangeSelector onChange={this.handleDateRangeChange} clearTrigger={this.state.clearDate} />

                      <div className="btn-group">
                        <button className="btn-new btn-new-filter" onClick={this.handleClear}>
                          Clear
                        </button>
                        <button className="btn-new btn-new-filter">seacrh</button>
                      </div>
                    </div> */}
                  </div>
                  <div className="wallet-summary-content">
                    <div className="payment-dashboard">
                      <PaymentCard
                        icon={CreditCard}
                        label={i18n.t('client_due')}
                        amount={this.state.wallet_summary?.client_due || 0}
                        className="payment-card-due"
                      />

                      <PaymentCard
                        icon={Pause}
                        label={i18n.t('hold')}
                        amount={this.state.wallet_summary?.hold_sum || 0}
                        className="payment-card-hold"
                        interactive={true}
                        // onClick={this.handleHoldClick}
                      />

                      <PaymentCard
                        icon={ArrowDown}
                        label={i18n.t('withdraw_requested')}
                        amount={this.state.wallet_summary?.admin_withdraw_sum || 0}
                        className="payment-card-withdraw"
                        interactive={true}
                        // onClick={this.handleWithdrawClick}
                      />

                      <PaymentCard
                        icon={Banknote}
                        label={i18n.t('balance')}
                        amount={this.state.wallet_summary?.balance_sum || 0}
                        className="payment-card-balance"
                      />
                    </div>
                    <div className="summary-cards">
                      <SummaryCard
                        icon={TrendingUp}
                        label={i18n.t('withdraw_refunded')}
                        amount={this.state.wallet_summary?.total_withdraw_sum || 0}
                        className="refund-card"
                        // onClick={this.handleRefundClick}
                      />

                      <SummaryCard
                        icon={Landmark}
                        label={i18n.t('total_balance')}
                        amount={this.state.wallet_summary?.total_balance_sum || 0}
                        className="balance-card"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Auction status */}
        <Modal
          show={open_status_popup}
          onHide={() => this.setState({ open_status_popup: false })}
          size="xl"
          style={{ '--bs-modal-width': '100%' }}
          fullscreen={true}
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg" style={{ width: '95%' }}>
              {types[status_type]}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {status_type === 'todays' && <DashboardTodays />}
            {status_type === 'active' && <DashboardWinners type={'A'} input={this.state.input} />}
            {status_type === 'previous' && <DashboardWinners type={'P'} input={this.state.input} />}
            {status_type === 'running' && <DashboardRunning input={this.state.input} />}
          </Modal.Body>
        </Modal>

        {/* Project section */}
        <Modal
          show={open_project_popup}
          onHide={() => this.setState({ open_project_popup: false })}
          size="xl"
          style={{ '--bs-modal-width': '100%' }}
          fullscreen={true}
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg" style={{ width: '95%' }}>
              {project_type === 'completed' ? i18n.t('paid_to_client') : i18n.t('client_approval')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DashboardApproval search_type={project_type} />
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
